import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch } from "react-redux";

import { editUser } from "../../../store/user/actions";
import { post } from "../../../actions/general";

import Form, { Checkbox, Title, Submit, Cancel, Validation } from "../../../components/Form";
import Modal from "../../../components/Modal";
import messages from "../messages";
import { IProps } from "./interfaces";
import { ICheckboxEvent, IOption } from "../../../types";
import { IUser } from "../../../store/user/models";

const ChangeCheckboxValue = ({ changingValue, close, changingLabel, changingName, options }: IProps) => {
    const [values, setValues] = useState<string[]>(changingValue);
    const [validation, setValidation] = useState<null | string>(null);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    const submit = () => {
        if (values.length === 0) {
            return setValidation("required");
        }
        setLoading(true);
        dispatch(post("change-" + changingName, { [changingName]: values }, (res: { data: { success: boolean, user: IUser } }) => {
            const { data } = res;
            if (data.success) {
                dispatch(editUser(data.user));
                if(close) close();
            } else {
                setValidation("unknownError");
                setLoading(false);
            }
        }));
    };
    const changeValue = (e: ICheckboxEvent) => {
        if (e.target.checked) {
            setValues(oldValues => [...oldValues, e.target.name!])
        } else {
            setValues(oldValues => oldValues.filter(oldValue => oldValue !== e.target.name!))
        }
        setValidation(null);
    };

    return (
        <Modal close={close}>
            <Form disabled={loading}>
                <Title>
                    <FormattedMessage {...messages.modifySomething} values={{ value: changingLabel }} />
                </Title>
                {validation && <Validation validation={validation} />}
                <div style={{ marginBottom: 12 }}>
                    {options.map((option: IOption<string>) => (
                        <div key={option.value}>
                            <Checkbox
                                disabled={loading}
                                label={option.label}
                                checked={values.indexOf(option.value) !== -1}
                                name={option.value}
                                onChange={changeValue}
                            />
                        </div>
                    ))}
                </div>
                <Submit onClick={submit} loading={loading}>
                    <FormattedMessage {...messages.modify} />
                </Submit>
                <Cancel onClick={close}>
                    <FormattedMessage {...messages.cancel} />
                </Cancel>
            </Form>
        </Modal>
    );
}

export default ChangeCheckboxValue;
